var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 12.9996,
    rx: 13,
    ry: 12.9996,
    fill: "#39F04F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.00034C8.35215 4.00167 10.7043 3.99767 13.0558 4.00233C14.5857 4.02563 16.1849 4.34986 17.4212 5.30058C18.4245 6.05156 19.0603 7.22664 19.2514 8.45565C19.4565 9.7712 19.348 11.1833 18.7055 12.3697C18.1542 13.4123 17.1756 14.1779 16.0937 14.6147C17.2375 17.074 18.3826 19.534 19.5124 22C18.3653 21.9927 17.2182 21.9987 16.0711 21.9967C15.0538 19.757 14.0351 17.5174 13.0192 15.2764C11.7303 15.2778 10.4413 15.2758 9.15307 15.2771C8.67372 14.3483 8.18904 13.4223 7.71035 12.4929C9.45 12.4935 11.1903 12.4929 12.9306 12.4929C13.7076 12.4862 14.5205 12.3064 15.1317 11.8011C15.6649 11.367 15.9605 10.6953 16.0251 10.0195C16.1123 9.20064 15.9505 8.29986 15.3633 7.68735C14.7415 7.0329 13.8028 6.81187 12.9286 6.80654C11.1897 6.80521 9.45067 6.80255 7.71169 6.80787C7.13713 5.87447 6.57323 4.93441 6 4.00034Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReya);
export default __webpack_public_path__ + "static/media/reya.aedc17f040f9c1fa7320e297ead03340.svg";
export { ForwardRef as ReactComponent };